import Constants from "./Constants";

const PATH_NO_BLOG = [
  Constants.VIEW_DOMAIN_INFO,
  Constants.VIEW_COMPLETE,
];

const PATH_BASIC_BLOG = [
  Constants.VIEW_DOMAIN_INFO,
  Constants.VIEW_COMPLETE,
];

const PATH_ADV_NEW = [
  Constants.VIEW_DOMAIN_INFO,
  Constants.VIEW_BLOG_CHOICE,
  Constants.VIEW_CONFIRM,
  Constants.VIEW_COMPLETE,
];

const PATH_ADV_MIGRATE = [
  Constants.VIEW_DOMAIN_INFO,
  Constants.VIEW_BLOG_CHOICE,
  Constants.VIEW_MIGRATION_DETAILS,
  Constants.VIEW_CONFIRM,
  Constants.VIEW_COMPLETE,
];

const PathMap = {
  [Constants.PATH_NO_BLOG]: PATH_NO_BLOG,
  [Constants.PATH_BASIC_BLOG]: PATH_BASIC_BLOG,
  [Constants.PATH_ADV_NEW]: PATH_ADV_NEW,
  [Constants.PATH_ADV_MIGRATE]: PATH_ADV_MIGRATE,
};

export default PathMap;
